import React from 'react';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import useTranslation from "../../customHooks/translations";
import { DEFAULT_THEME_COLOR, DEFAULT_GRADIENT, DEFAULT_GRADIENT_HOVER } from "../../constants/theme";
import { Link, useNavigate } from "react-router-dom";
import LockOpenIcon from "@mui/icons-material/LockOpen";

const TooManyRequestModal = ({ isOpen, onClose, onConfirm, isIncognito }) => {
  const translation = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90%', sm: 420 },
        background: 'linear-gradient(135deg, #0d1b2a 0%, #0d3d2e 100%)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: 3,
        boxShadow: '0 16px 48px rgba(0,0,0,0.6)',
        p: 4,
        textAlign: 'center',
        outline: 'none',
      }}>
        <LockOpenIcon sx={{ fontSize: 56, color: DEFAULT_THEME_COLOR, mb: 2 }} />

        <Typography id="modal-modal-title" variant="h5" fontWeight="bold" sx={{ color: 'white', mb: 1 }}>
          {isIncognito
            ? translation.modals.tooManyRequests.niceTry
            : translation.modals.tooManyRequests.youHaveReachedYourLimit}
        </Typography>

        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', mb: 3 }}>
          {isIncognito
            ? 'Create a free account to unlock unlimited access.'
            : 'Register for free to get full access to all places.'}
        </Typography>

        <Button
          fullWidth
          variant="contained"
          onClick={() => navigate('/register')}
          sx={{
            background: DEFAULT_GRADIENT,
            color: 'white',
            fontWeight: 700,
            py: 1.5,
            fontSize: '1rem',
            borderRadius: 2,
            boxShadow: '0 4px 16px rgba(54,201,162,0.35)',
            '&:hover': { background: DEFAULT_GRADIENT_HOVER },
            mb: 2,
          }}
        >
          {translation.modals.tooManyRequests.register}
        </Button>

        <Link
          to="https://newsletter.freak-land.com"
          target="_blank"
          style={{ color: DEFAULT_THEME_COLOR, fontSize: '0.85rem' }}
        >
          {translation.modals.tooManyRequests.newsletter}
        </Link>
      </Box>
    </Modal>
  );
};

export default TooManyRequestModal;
